import english from '../../translations/en.json';
import romanian from '../../translations/ro.json';
import russian from '../../translations/ru.json';

export const TRANSLATIONS = {
  en: english,
  ro: romanian,
  ru: russian,
} as const;
